import { UseQueryOptions, QueryKey, useQuery } from '@tanstack/react-query';
import apiClient from '@/lib/api-client';

const hpmvKey = ['hpmv'];

const fetchAllRecords = async (baseUrl: string): Promise<any> => {
  let offset = 0;
  let allFeatures: any[] = [];
  let finished = false;

  while (!finished) {
    const urlObj = new URL(baseUrl);
    urlObj.searchParams.set('resultOffset', offset.toString());
    urlObj.searchParams.set('resultRecordCount', '2000');

    const response: any = await apiClient.get(urlObj.toString(), {
      withCredentials: false,
    });

    allFeatures = allFeatures.concat(response?.features || []);

    if (response.features.length < 2000) {
      finished = true;
    } else {
      offset += 2000;
    }
  }

  return { type: 'FeatureCollection', features: allFeatures };
};

const getHpmvData = async (): Promise<any[]> => {
  const urls = [
    'https://services.arcgis.com/CXBb7LAjgIIdcsPt/ArcGIS/rest/services/Freight_HighProductivityMotorVehicleRoutes_MOUAgreed/FeatureServer/0/query?where=1%3D1&outFields=*&f=geojson',
    'https://services.arcgis.com/CXBb7LAjgIIdcsPt/ArcGIS/rest/services/Freight_HighProductivityMotorVehicleRoutes_MOUAgreed/FeatureServer/1/query?where=1%3D1&outFields=*&f=geojson',
    'https://services.arcgis.com/CXBb7LAjgIIdcsPt/ArcGIS/rest/services/Bridges_Not_Permitted_To_Cross/FeatureServer/0/query?where=1%3D1&outFields=*&f=geojson',
  ];

  const responses = await Promise.all(urls.map((url) => fetchAllRecords(url)));

  return responses;
};

export const useHPMV = (
  options?: Omit<
    UseQueryOptions<any[], Error, any[], QueryKey>,
    'queryKey' | 'queryFn'
  >,
) =>
  useQuery({
    queryKey: hpmvKey,
    queryFn: getHpmvData,
    staleTime: Infinity,
    ...options,
  });
